export type ContentType = 'video' | 'article' | 'infographic' | 'pdf';
export type ScheduleType = 'immediate' | 'scheduled' | 'ai-optimized';
export type TargetType = 'all' | 'condition' | 'language' | 'custom';

export interface EducationalContent {
  id: string;
  title: string;
  description: string;
  type: ContentType;
  category: string;
  language: 'en' | 'es';
  aiGenerated: boolean;
  tags: string[];
  createdAt: Date;
  viewCount: number;
  engagementRate: number;
}

/** Shape returned by the API for education content items — matches EducationContentResponse */
export interface ApiEducationContent {
  id: number;
  content_topic: string;
  content_type: string;
  category: string;
  language: string;
  additional_instructions: string;
  content_url: string;
  content_title: string;
  content_description: string;
  video_channel: string;
  video_thumbnail_url: string;
  ai_ranking_score: number;
  ai_ranking_reason: string;
  article_summary: string | null;
  word_count: number | null;
  generated_by_admin_id: number;
  created_at: string;
  updated_at: string;
}

export function mapApiToEducationalContent(item: ApiEducationContent): EducationalContent {
  return {
    id: String(item.id),
    title: item.content_title || item.content_topic,
    description: item.content_description || item.article_summary || item.additional_instructions || '',
    type: (item.content_type as ContentType) ?? 'article',
    category: item.category,
    language: (item.language as 'en' | 'es') ?? 'en',
    aiGenerated: true,
    tags: [],
    createdAt: item.created_at ? new Date(item.created_at) : new Date(),
    viewCount: 0,
    engagementRate: item.ai_ranking_score ?? 0,
  };
}

export interface AssignmentConfig {
  contentId: string;
  targetType: TargetType;
  targetCriteria: string[];
  scheduleType: ScheduleType;
  scheduledDate?: string;
  scheduledTime?: string;
  selectedPatients: string[];
}
